import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useBillingStatus } from './useBillingStatus';

/**
 * `/billing/success` — Stripe redirects here after payment. The webhook that
 * flips the subscription to `Active` lags the redirect, so poll status every
 * ~2s for ~20s. On `Active` → `/dashboard`. If it never flips, offer a manual
 * recheck / dashboard link rather than spinning forever.
 *
 * Functional scaffolding — unstyled.
 */
export function CheckoutSuccess() {
  const [stopped, setStopped] = useState(false);
  const { data } = useBillingStatus({ refetchInterval: stopped ? false : 2000 });

  // Cap the polling window (~10 tries at 2s). Restart when polling resumes.
  useEffect(() => {
    if (stopped) return;
    const timer = setTimeout(() => setStopped(true), 20_000);
    return () => clearTimeout(timer);
  }, [stopped]);

  if (data?.status === 'Active' || data?.status === 'PastDue') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div>
      <p>Finishing setup…</p>
      {stopped ? (
        <>
          <p>This is taking longer than expected.</p>
          <button type="button" onClick={() => setStopped(false)}>
            Check again
          </button>
          <button type="button" onClick={() => window.location.assign('/dashboard')}>
            Go to dashboard
          </button>
        </>
      ) : null}
    </div>
  );
}
